<template>
    <div>
        <ValidationObserver ref="observer">
            <modal-cadu close :width="1131.52" v-model="valueData">
                <div slot="all" class="py-10 px-10">
                    <div slot="header" class="primary1--text headline font-weight-bold">
                        {{ mode === 'view' ? 'VISUALIZAR': 'EDITAR' }} QUANTIDADE DE COOPERADOS
                    </div>
                    <div slot="body">
                        <v-row>
                            <v-col cols="12" sm="3">
                                <validation-provider name="competencia" mode="eager" v-slot="{ errors }">
                                    <input-cadu
                                        :errorMessage="errors[0]"
                                        title="Competência"
                                        v-model="competencia"
                                        icon="calendar"
                                        v-mask="'##/####'"
                                        :colorText="$vuetify.theme.themes.light.fontColor1"
                                        disabled
                                    />
                                </validation-provider>
                            </v-col>
                            <v-col cols="12" sm="3" class="ml-6">
                                <validation-provider name="ultimaAtualizacao" mode="eager" v-slot="{ errors }">
                                    <input-cadu
                                        :errorMessage="errors[0]"
                                        title="Última Atualização"
                                        v-model="ultimaAtualizacao"
                                        icon="calendar"
                                        v-mask="'##/##/####'"
                                        :colorText="$vuetify.theme.themes.light.fontColor1"
                                        disabled
                                    />
                                </validation-provider>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="12" sm="3" class="mr-8">
                                <v-row style="position: relative;">
                                    <v-col cols="12">
                                        <v-row>
                                            <v-col cols="12" class="primary1--text" style="position: relative; font-size: 1rem;">
                                              Cooperados Ativos
                                              <tooltip-help width="400" text="Médicos cooperados que exercem atividade médica, geram produção e possuem vínculo com a cooperativa."/>
                                            </v-col>
                                        </v-row>
                                        <validation-provider name="cooperadosAtivos" rules="required|max:7" mode="eager" v-slot="{ errors }">
                                            <input-cadu
                                                :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###']"
                                                :errorMessage="errors[0]"
                                                onlyNumber
                                                v-model="cooperadosAtivos"
                                                :colorText="$vuetify.theme.themes.light.fontColor1"
                                                :disabled="mode === 'view'"
                                                textAlign="end"
                                            />
                                        </validation-provider>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="3">
                                <v-row style="position: relative;">
                                    <v-col cols="12">
                                        <v-row>
                                            <v-col cols="12" class="primary1--text" style="position: relative; font-size: 1rem;">
                                              Cooperados Inativos
                                              <tooltip-help width="400" text="Médicos cooperados que possuem vínculo com a cooperativa, contudo, não exercem mais atividade médica."/>
                                            </v-col>
                                        </v-row>
                                        <validation-provider name="cooperadosInativos" rules="required|max:7" mode="eager" v-slot="{ errors }">
                                            <input-cadu
                                                :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###']"
                                                :errorMessage="errors[0]"
                                                onlyNumber
                                                v-model="cooperadosInativos"
                                                :colorText="$vuetify.theme.themes.light.fontColor1"
                                                :disabled="mode === 'view'"
                                                textAlign="end"
                                            />
                                        </validation-provider>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="pt-4">
                            <v-col cols="12" sm="3" class="mx-4">
                                <div class="primary1--text subtitle-1 grey1--text">
                                    Total de Cooperados
                                </div>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-row no-gutters align="center" justify="start" style="height: 100%">
                                    <v-col cols="12">
                                        <input-cadu
                                          :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###']"
                                          title=""
                                          :value="totalCooperados"
                                          :colorText="$vuetify.theme.themes.light.fontColor1"
                                          disabled
                                          textAlign="end"
                                          colorBgField="#333"
                                          colorInput="white"
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </div>
                    <div slot="footer">
                        <div v-if="mode === 'view'">
                            <v-row align="end" justify="end">
                                <v-col cols="auto">
                                    <button-cadu @click="$emit('input', false)" :backColor="$vuetify.theme.themes.light.primary2" text="VOLTAR"/>
                                </v-col>
                            </v-row>
                        </div>
                        <div v-else>
                            <v-row align="start" justify="start">
                                <v-col cols="auto">
                                    <button-cadu
                                        outline
                                        @click="verificarEdicao"
                                    >
                                        CANCELAR
                                    </button-cadu>
                                </v-col>
                                <v-row align="end" justify="end" class="mr-2">
                                    <v-col cols="auto">
                                        <button-cadu
                                            :backColor="$vuetify.theme.themes.light.primary2"
                                            class="px-4"
                                            @click="clean"
                                        >
                                            LIMPAR
                                        </button-cadu>
                                    </v-col>
                                    <v-col
                                        cols="auto"
                                    >
                                        <button-cadu
                                            @click="putCooperado"
                                        >
                                            SALVAR
                                        </button-cadu>
                                    </v-col>
                                </v-row>
                            </v-row>
                        </div>
                    </div>
                </div>
            </modal-cadu>
        </ValidationObserver>
        <overlay-loading :value="loadingOverlay"/>
        <modal-cancelar
            v-model="showModalCancelar"
            @cancelar-edicao="cancelarEdicao()"
        />
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Cooperado from '@/services/Perfil/Cooperado'
import { isEqual } from 'lodash'
import { mask } from 'vue-the-mask'
import { EventBus } from '@/services/EventBus/EventBus'

export default {
  directives: {
    mask
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    mode: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      valueData: this.value,
      competencia: '08/2018',
      ultimaAtualizacao: '01/07/2018',
      cooperadosAtivos: 0,
      cooperadosInativos: 0,
      loadingOverlay: false,
      tokenBearer: localStorage.getItem('tokenBearer'),
      cloneCooperado: {},
      showModalCancelar: false
    }
  },
  methods: {
    cancelarEdicao () {
      this.showModalCancelar = false;
      this.start(this.cloneCooperado);
      this.$emit('input', false);
    },
    verificarEdicao () {
      let newObj = {
        'id': this.id,
        'competencia': this.competencia,
        'dataAtualizacao': this.ultimaAtualizacao,
        'qtCooperadosAtivos': this.cooperadosAtivos * 1,
        'qtCooperadosInativos': this.cooperadosInativos * 1
      }

      if (!isEqual(this.cloneCooperado, newObj)) {
        this.showModalCancelar = true
      } else {
        this.$emit('input', false)
      }
    },
    clean () {
      this.cooperadosAtivos = 0
      this.cooperadosInativos = 0
    },
    start (row) {
      this.competencia = row.competencia
      this.ultimaAtualizacao = row.dataAtualizacao
      this.cooperadosAtivos = row.qtCooperadosAtivos
      this.cooperadosInativos = row.qtCooperadosInativos
      this.id = row.id

      this.cloneCooperado = {
        id: this.id,
        competencia: this.competencia,
        dataAtualizacao: this.ultimaAtualizacao,
        qtCooperadosAtivos: this.cooperadosAtivos,
        qtCooperadosInativos: this.cooperadosInativos
      }
    },
    async putCooperado (justificativa) {
      if (await this.$refs.observer.validate()) {
        this.loadingOverlay = true
        let cooperado = new Cooperado(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

        let data = {
          competencia: this.competencia,
          id: this.id,
          qtCooperadosAtivos: this.cooperadosAtivos,
          qtCooperadosInativos: this.cooperadosInativos,
          justificativa
        }

        try {
          let response = await cooperado.putCooperado(data)
          let mensagem = response.data.mensagem
          let gerouPendencia = response.data.gerouPendencia
          if (gerouPendencia) {
            EventBus.$emit('pendenteModal', { mensagem, gerouPendencia })
          } else {
            this.id = response.data.idCompetencia
            this.$emit('success')
          }
          EventBus.$emit('resolverAlertaNotificaoPendente', { tipoNotificacao: 'NUMERO_COOPERADOS' });
        } catch (err) {
          this.$emit('error', err.response)
        }
        this.loadingOverlay = false
      }
    }
  },
  computed: {
    totalCooperados () {
      let ativo = Number(this.cooperadosAtivos) || 0
      let inativo = Number(this.cooperadosInativos) || 0
      let result = ativo + inativo
      return result || 0
    }
  },
  watch: {
    value () {
      this.valueData = this.value
    },
    valueData () {
      if (!this.valueData) {
        this.$emit('input', false)
      }
    }
  }
}
</script>
